import { Injectable } from '@angular/core';
@Injectable()
export class CorrectYeKeService {
    public static getCorrectYeKe(text: string): string {
        if (!(text))
            return text;
        var s = "";
        for (var i = 0; i <= text.length; i++) {
            if (text[i]) {
                switch (text[i]) {
                    case String.fromCharCode(1705):
                        s = s + String.fromCharCode(1603);
                        break;
                    case String.fromCharCode(1609):
                    case String.fromCharCode(1740):
                        s = s + String.fromCharCode(1610);
                        break;
                    default:
                        s += text[i];
                        break;
                }
            }
        }
        if (!(s))
            return text;
        return s;
    }
}
